import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import HeroPromoBanner from "@/components/landing/HeroPromoBanner";
import PainPoints from "@/components/landing/PainPoints";
import Experts from "@/components/landing/Experts";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import Method from "@/components/landing/Method";
import Articles from "@/components/landing/Articles";
import TestCTA from "@/components/landing/TestCTA";
import FeaturedProducts from "@/components/landing/FeaturedProduct";
import DiagnosticCTA from "@/components/landing/DiagnosticCTA";
import Footer from "@/components/landing/Footer";
import ConversionPopup from "@/components/landing/ConversionPopup";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="bg-white text-ink-900 overflow-x-hidden">
            <Navbar />
            <Hero />
            <HeroPromoBanner />
            <PainPoints />
            <Experts />
            <Stats />
            <Testimonials />
            <Method />
            <Articles />
            <TestCTA />
            <FeaturedProducts />
            <DiagnosticCTA />
            <Footer />
            <ConversionPopup />
        </main>
    );
}
